import React, { useState, useEffect } from "react";
import { shuffle, slice } from 'lodash';
import { Link } from "@StarberryUtils"
import { useQuery } from '@apollo/client';
import gql from "graphql-tag"
import ModalTiny from "react-bootstrap/Modal"
import Contact from "../forms/contact-form"

import Img01 from "../../images/propertyDetails/img01.png";
import Img02 from "../../images/propertyDetails/img02.png";
import Img03 from "../../images/propertyDetails/img03.png";
import Img04 from "../../images/propertyDetails/img04.png";
import ImageTransform from "../common/ggfx-client/module/components/image-transform";

const NEGOTIATOR = gql`
query GETNEG($URL: String!){
    offices(where:{CRM_ID: $URL}){
        Primary_Email
        Primary_Phone
        Sales_Phone
        Sales_Email
        Lettings_Phone
        Lettings_Email
        New_Homes_Phone
        New_Homes_Email
        CRM_ID
        Team {
          Name
          id
          Image {
            url
            alternativeText
          }
        }
    }
}
`;

function Negotiator(props) {

    const [modalSharefrndformOpen, setSharefrndformOpen] = React.useState(false);
    const openSharefrndformModal = () => {
        setSharefrndformOpen(true);
    }
    const closeSharefrndformModal = () => {
        setSharefrndformOpen(false);
    }

    const { loading, error, data } = useQuery(NEGOTIATOR, {
        variables: { URL: props.id }
    });

    useEffect(()=>{
        if(data?.offices && data?.offices.length > 0){
            props.setPrimaryPhone(data?.offices[0].Primary_Phone)
        }
    },[data])

    if (loading) return (
        <p>loading...</p>
    )

    return (
        <div className="about-us">
            {data.offices.length > 0 &&
                <>
                    {data.offices.map((neg, index) => {

                        let teamArr = [];
                        if (neg.Team.length > 0)
                            teamArr = slice(shuffle(neg.Team), 0, 2);

                        return (
                            <>
                                <div className="admin-img">
                                    {teamArr.map((person, index) => {
                                        const image_url = person.Image.url

                                        let processedImages = JSON.stringify({});
                                        if (person?.imagetransforms?.Image_Transforms) {
                                            processedImages = person.imagetransforms.Image_Transforms;
                                        }
                                        return (
                                            <div className="admin">
                                                <ImageTransform imagesources={image_url} renderer="srcSet" imagename="property.images.neg_image" attr={{ alt: person.Title + ' - Redbrik', class: '' }} imagetransformresult={processedImages} id={person.id} />
                                            </div>
                                        )
                                    })}
                                </div>
                                <div className="contact-info">
                                    <div className="prop-info">Do you have a property to Sell or Let?
                                        <span className="contact-info"><a href="/contact/">Get in touch</a> with our team to book a valuation.</span>
                                    </div>
                                    { /*<a href={`tel:${props.search_type=='sales'? neg.Sales_Phone:props.search_type=='lettings'? neg.Lettings_Phone: neg.New_Homes_Phone}`} className="tel">
                        {props.search_type=='sales'? neg.Sales_Phone:props.search_type=='lettings'? neg.Lettings_Phone: neg.New_Homes_Phone}
                    </a>
                    <a href="javascript:void(0)" onClick={()=> { openSharefrndformModal();}} className="mail">
                        {props.search_type=='sales'? neg.Sales_Email:props.search_type=='lettings'? neg.Lettings_Email: neg.New_Homes_Email}
                    </a>*/ }
                                </div>

                                <ModalTiny show={modalSharefrndformOpen} onHide={closeSharefrndformModal} className="book-a-viewing-modal">
                                    <ModalTiny.Header closeButton className="contact-close-btn">
                                        <ModalTiny.Title className="w-100"><h2 className="text-center mb-0 text-uppercase">Contact</h2></ModalTiny.Title>
                                    </ModalTiny.Header>

                                    <ModalTiny.Body className="event-section">
                                        <Contact to_email_id={neg.Primary_Email} formLabel="Office Contact - Property Details" />
                                    </ModalTiny.Body>
                                </ModalTiny>

                            </>
                        )
                    })}
                </>
            }
        </div>
    )
}

export default Negotiator;
